/* The Shelf: category chips re-sort the boxes; boxes slide on whole frames (Flip with a stepped ease). */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  if (window.gsap && window.Flip) gsap.registerPlugin(Flip);
  WH.register('shelf', function (sec) {
    var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-shelf-chip]'));
    var boxes = Array.prototype.slice.call(sec.querySelectorAll('[data-box]'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var cat = chip.getAttribute('data-shelf-chip');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        WH.sound.play('pop');
        var state = WH.anim && window.Flip ? Flip.getState(boxes) : null;
        boxes.forEach(function (b) { b.hidden = !(cat === 'all' || b.getAttribute('data-cat') === cat); });
        if (state) {
          Flip.from(state, { duration: 0.5, ease: WH.sm('power2.inOut', 0.5), absolute: true,
            onEnter: function (els) { return gsap.fromTo(els, { scale: 0.3, rotation: -10, opacity: 0 }, { scale: 1, rotation: 0, opacity: 1, duration: 0.42, ease: WH.sm('back.out(2)', 0.42), stagger: 0.05 }); },
            onLeave: function (els) { return gsap.to(els, { scale: 0.3, opacity: 0, duration: 0.25, ease: WH.sm('power1.in', 0.25) }); } });
        }
      });
    });
  });
})();
